import { Controller } from "@hotwired/stimulus"
import { isMobileScreen } from '../helpers/media_helpers'

export default class extends Controller {
  static targets = ['button', 'dialog']
  static values = { id: String }

  idValueChanged(id) {
    this.#close()
    this.#open(id)
  }

  toggle({ currentTarget }) {
    const id = currentTarget.parentNode.id

    this.idValue = (this.idValue !== id) ? id : ''
  }

  closeOnClickOutside({ target }) {
    if (isMobileScreen()) return

    for (const elem of [...this.buttonTargets, ...this.dialogTargets]) {
      if (elem.contains(target)) return
    }

    this.idValue = ''
  }

  #open(id) {
    if (!id) return

    const item = document.getElementById(id)
    item.querySelector('dialog').show()

    this.dispatch('open', { detail: { id } })
  }

  #close() {
    this.dialogTargets.forEach(v => v.close())

    this.dispatch('close', { detail: { newId: this.idValue } })
  }
}
